import { useEffect } from "react";

function useStyleSheet(stylesheet) {
  useEffect(() => {
    if (!stylesheet) return;
    const styleTag = document.createElement("style");
    styleTag.innerHTML = stylesheet;
    document.head.appendChild(styleTag);

    return () => styleTag.remove();
  }, [stylesheet]);

  return null;
}

export default useStyleSheet;
